import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ParameterActServiceListComponent } from './parameter-act-service-list.component';
import { ActListModule } from 'src/app/generated/ui/list/Act/Act.module';

@NgModule({
  declarations: [ParameterActServiceListComponent],
  imports: [CommonModule, ActListModule],
  exports: [ParameterActServiceListComponent]
})
export class ParameterActServiceListModule {}
